import { CacheConfig, Observable, RequestParameters, Variables } from 'relay-runtime';
import { RelayQueryResultCache } from './relayQueryResultCache';
import { getServerStream } from '@confluence/ssr-data-streaming/entry-points/server';
import { createIdentifierFromQuery } from '@confluence/graphql/entry-points/createIdentifierFromQuery';

let ssrQueryResultCache: RelayQueryResultCache | null = null;
let isSSRDataLinkEnabled = false;
const SSR_NAMESPACE = 'cgraphql';

export interface Event {
	type: 'result';
	operation: string;
	variables: Variables;
	result: any;
}

export const readDataFromStream = (
	request: RequestParameters,
	variables: Variables,
): object | null => {
	if (window.__SSR_REACT_STREAMING__ && ssrQueryResultCache && request.text) {
		const queryIdentifier = createIdentifierFromQuery(request.text);
		const result = ssrQueryResultCache.getMatchingResult(queryIdentifier, variables);
		return result;
	}
	return null;
};

export const writeDataToStream = (
	request: RequestParameters,
	variables: Variables,
	cacheConfig: CacheConfig,
	promise: Promise<any>,
): Observable<any> => {
	if (!isSSRDataLinkEnabled || !request.text) {
		return Observable.from(promise);
	}

	return Observable.create((observer) => {
		const data = getServerStream(SSR_NAMESPACE);
		promise
			.then((result: any) => {
				if (result.data === null && result.errors !== null) {
					observer.error(result.errors);
					observer.complete();
					return;
				}

				// Use the original query if available in context, otherwise use the request text
				const query = (cacheConfig.metadata?.originalQuery as string) ?? request.text;
				if (query && typeof query === 'string') {
					const event: Event = {
						type: 'result',
						operation: createIdentifierFromQuery(query),
						variables,
						result,
					};
					data.emit(event);
				}

				observer.next(result);
				observer.complete();
			})
			.catch((error: any) => {
				observer.error(error);
			});
	});
};

export function enableSSRDataLink(): void {
	isSSRDataLinkEnabled = true;
}

export function disableSSRDataLink(): void {
	isSSRDataLinkEnabled = false;
}

export const initializeSSR = (namespace: string): void => {
	if (window.__SSR_REACT_STREAMING__) {
		ssrQueryResultCache = new RelayQueryResultCache(namespace);
	}
};
